import React from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { compose, lifecycle } from 'recompose';
import { Spin } from 'antd';
import styled from 'styled-components';

import { actions as authActions } from 'modules/auth';
import { redirectIfNotLoggedIn } from 'utils/HOCs/redirect';

const SpinContainer = styled.div`
  text-align: center;
  padding: 40px 0;
`;

const enhance = compose(
  redirectIfNotLoggedIn,
  connect(
    null,
    {
      logout: authActions.logout,
      push,
    }
  ),
  lifecycle({
    async componentDidMount() {
      await this.props.logout();
      this.props.push('/login');
    }
  }),
);

const Logout = () => {
  return (
    <SpinContainer>
      <Spin tip="Logging out..." />
    </SpinContainer>
  );
};

export default enhance(Logout);



// WEBPACK FOOTER //
// ./src/pages/Auth/Logout.js